// Auth
export const REQUEST_AUTHENTICATION = 'REQUEST_AUTHENTICATION'
export const RECEIVE_AUTHENTICATION_SUCCESS = 'RECEIVE_AUTHENTICATION_SUCCESS'
export const RECEIVE_AUTHENTICATION_ERROR = 'RECEIVE_AUTHENTICATION_ERROR'
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION'
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR'

// Account
export const REQUEST_FORGOT_PASSWORD_EMAIL = 'REQUEST_FORGOT_PASSWORD_EMAIL'
export const REQUEST_FORGOT_PASSWORD_ERROR = 'REQUEST_FORGOT_PASSWORD_ERROR'
export const REQUEST_FORGOT_PASSWORD_SUCCESS = 'REQUEST_FORGOT_PASSWORD_SUCCESS'
export const REQUEST_RESET_PASSWORD_ERROR = 'REQUEST_RESET_PASSWORD_ERROR'
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS'
export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT'

// User
export const REQUEST_USER_ERROR = 'REQUEST_USER_ERROR'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const CLEAR_USER = 'CLEAR_USER'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR'
export const ARCHIVE_USER_SUCCESS = 'ARCHIVE_USER_SUCCESS'
export const ARCHIVE_USER_ERROR = 'ARCHIVE_USER_ERROR'
export const RESTORE_USER = 'RESTORE_USER'
export const DELETE_USER = 'DELETE_USER'
export const REQUEST_USER_LIST_SUCCESS = 'REQUEST_USER_LIST_SUCCESS'
export const REQUEST_USER_LIST_ERROR = 'REQUEST_USER_LIST_ERROR'
export const REQUEST_USER_LIST_NROLES_SUCCESS = 'REQUEST_USER_LIST_NROLES_SUCCESS'
export const REQUEST_USER_LIST_NROLES_ERROR = 'REQUEST_USER_LIST_NROLES_ERROR'
export const REQUEST_ARCHIVE_USER_LIST_SUCCESS = 'REQUEST_ARCHIVE_USER_LIST_SUCCESS'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const REQUEST_CREW_LEAD_LIST_ERROR = 'REQUEST_CREW_LEAD_LIST_ERROR'
export const REQUEST_CREW_LEAD_LIST_SUCCESS = 'REQUEST_CREW_LEAD_LIST_SUCCESS'

// Crew
export const REQUEST_GET_CREW_SUCCESS = 'REQUEST_GET_CREW_SUCCESS'
export const REQUEST_GET_CREW_ERROR = 'REQUEST_GET_CREW_ERROR'
export const REQUEST_CREATE_CREW_SUCCESS = 'REQUEST_CREATE_CREW_SUCCESS'
export const REQUEST_CREATE_CREW_ERROR = 'REQUEST_CREATE_CREW_ERROR'
export const REQUEST_GET_CREW_USERS_SUCCESS = 'REQUEST_GET_CREW_USERS_SUCCESS'
export const REQUEST_GET_CREW_USERS_ERROR = 'REQUEST_GET_CREW_USERS_ERROR'
export const REQUEST_GET_CREW_TASKS_SUCCESS = 'REQUEST_GET_CREW_TASKS_SUCCESS'
export const REQUEST_GET_CREW_TASKS_ERROR = 'REQUEST_GET_CREW_TASKS_ERROR'
export const REQUEST_UPDATE_CREW_SUCCESS = 'REQUEST_UPDATE_CREW_SUCCESS'
export const REQUEST_UPDATE_CREW_ERROR = 'REQUEST_UPDATE_CREW_ERROR'
export const REQUEST_DELETE_CREW_SUCCESS = 'REQUEST_DELETE_CREW_SUCCESS'
export const REQUEST_DELETE_CREW_ERROR = 'REQUEST_DELETE_CREW_ERROR'
export const CLEAR_CREW = 'CLEAR_CREW'

// Task
// get single task
export const REQUEST_GET_TASK_SUCCESS = 'REQUEST_GET_TASK_SUCCESS'
export const REQUEST_GET_TASK_ERROR = 'REQUEST_GET_TASK_ERROR'
export const CLEAR_TASK = 'CLEAR_TASK'
export const CLEAR_TASKS = 'CLEAR_TASKS'
// get tasks for map
export const SET_MAP_TASKS_SUCCESS = 'SET_MAP_TASKS_SUCCESS'
export const SET_MAP_TASKS_ERROR = 'SET_MAP_TASKS_ERROR'
// create & update
export const REQUEST_CREATE_TASK_SUCCESS = 'REQUEST_CREATE_TASK_SUCCESS'
export const REQUEST_CREATE_TASK_ERROR = 'REQUEST_CREATE_TASK_ERROR'
export const REQUEST_UPDATE_TASK_SUCCESS = 'REQUEST_UPDATE_TASK_SUCCESS'
export const REQUEST_UPDATE_TASK_ERROR = 'REQUEST_UPDATE_TASK_ERROR'
// Sub-update calls (add/remove crew && archive/restore)
export const REQUEST_ADD_CREW_TO_TASK_SUCCESS = 'REQUEST_ADD_CREW_TO_TASK_SUCCESS'
export const REQUEST_ADD_CREW_TO_TASK_ERROR = 'REQUEST_ADD_CREW_TO_TASK_ERROR'
export const REQUEST_REMOVE_CREW_FROM_TASK_SUCCESS = 'REQUEST_REMOVE_CREW_FROM_TASK_SUCCESS'
export const REQUEST_REMOVE_CREW_FROM_TASK_ERROR = 'REQUEST_REMOVE_CREW_FROM_TASK_ERROR'
export const REQUEST_ARCHIVE_TASK_SUCCESS = 'REQUEST_ARCHIVE_TASK_SUCCESS'
export const REQUEST_ARCHIVE_TASK_ERROR = 'REQUEST_ARCHIVE_TASK_ERROR'
export const REQUEST_RESTORE_TASK_SUCCESS = 'REQUEST_RESTORE_TASK_SUCCESS'
export const REQUEST_RESTORE_TASK_ERROR = 'REQUEST_RESTORE_TASK_ERROR'
// filtering, sorting and get alls
export const SEARCH_OBJECT = 'SEARCH_OBJECT'
export const REQUEST_GET_SEARCH_TASKS_SUCCESS = 'REQUEST_GET_SEARCH_TASKS_SUCCESS'
export const REQUEST_GET_SEARCH_TASKS_ERROR = 'REQUEST_GET_SEARCH_TASKS_ERROR'
export const REQUEST_GET_TASKS_ARCHIVED_SUCCESS = 'REQUEST_GET_TASKS_ARCHIVED_SUCCESS'
export const REQUEST_GET_TASKS_ARCHIVED_ERROR = 'REQUEST_GET_TASKS_ARCHIVED_ERROR'
export const REQUEST_GET_UNSCHEDULED_TASKS_SUCCESS = 'REQUEST_GET_UNSCHEDULED_TASKS_SUCCESS'
export const REQUEST_GET_UNSCHEDULED_TASKS_ERROR = 'REQUEST_GET_UNSCHEDULED_TASKS_ERROR'
export const REQUEST_GET_SCHEDULED_TASKS_SUCCESS = 'REQUEST_GET_SCHEDULED_TASKS_SUCCESS'
export const REQUEST_GET_SCHEDULED_TASKS_ERROR = 'REQUEST_GET_SCHEDULED_TASKS_ERROR'
// sort tasks
export const SET_SORT_DIRECTION = 'SET_SORT_DIRECTION'
export const CLEAR_SORT = 'CLEAR_SORT'
// Get list information for search bar
export const REQUEST_GET_TASK_ISD_LIST_SUCCESS = 'REQUEST_GET_TASK_ISD_LIST_SUCCESS'
export const REQUEST_GET_TASK_ISD_LIST_ERROR = 'REQUEST_GET_TASK_ISD_LIST_ERROR'
export const REQUEST_GET_TASK_START_LIST_SUCCESS = 'REQUEST_GET_TASK_START_LIST_SUCCESS'
export const REQUEST_GET_TASK_START_LIST_ERROR = 'REQUEST_GET_TASK_START_LIST_ERROR'
export const REQUEST_GET_TASK_LOCATION_LIST_SUCCESS = 'REQUEST_GET_TASK_LOCATION_LIST_SUCCESS'
export const REQUEST_GET_TASK_LOCATION_LIST_ERROR = 'REQUEST_GET_TASK_LOCATION_LIST_ERROR'
export const REQUEST_GET_TASK_CPA_LIST_SUCCESS = 'REQUEST_GET_TASK_CPA_LIST_SUCCESS'
export const REQUEST_GET_TASK_CPA_LIST_ERROR = 'REQUEST_GET_TASK_CPA_LIST_ERROR'
export const REQUEST_GET_WORKORDER_NUMBERS_SEARCH_SUCCESS = 'REQUEST_GET_WORKORDER_NUMBERS_SEARCH_SUCCESS'
export const REQUEST_GET_WORKORDER_NUMBERS_SEARCH_ERROR = 'REQUEST_GET_WORKORDER_NUMBERS_SERACH_ERROR'

// Scheduling
export const REQUEST_GET_SCHEDULE_BY_TASK_SUCCESS = 'REQUEST_GET_SCHEDULE_BY_TASK_SUCCESS'
export const REQUEST_GET_SCHEDULE_BY_TASK_ERROR = 'REQUEST_GET_SCHEDULE_BY_TASK_ERROR'
export const REQUEST_CREATE_SCHEDULE_SUCCESS = 'REQUEST_CREATE_SCHEDULE_SUCCESS'
export const REQUEST_CREATE_SCHEDULE_ERROR = 'REQUEST_CREATE_SCHEDULE_ERROR'
export const REQUEST_UPDATE_SCHEDULE_SUCCESS = 'REQUEST_UPDATE_SCHEDULE_SUCCESS'
export const REQUEST_UPDATE_SCHEDULE_ERROR = 'REQUEST_UPDATE_SCHEDULE_ERROR'
export const REQUEST_DELETE_SCHEDULE_SUCCESS = 'REQUEST_DELETE_SCHEDULE_SUCCESS'
export const REQUEST_DELETE_SCHEDULE_ERROR = 'REQUEST_DELETE_SCHEDULE_ERROR'


// Work Order
export const REQUEST_GET_WORKORDER_SUCCESS = 'REQUEST_GET_WORKORDER_SUCCESS'
export const REQUEST_GET_WORKORDER_ERROR = 'REQUEST_GET_WORKORDER_ERROR'
export const REQUEST_GET_WORKORDER_NUMBERS_SUCCESS = 'REQUEST_GET_WORKORDER_NUMBERS_SUCCESS'
export const REQUEST_GET_WORKORDER_NUMBERS_ERROR = 'REQUEST_GET_WORKORDER_NUMBERS_ERROR'
export const REQUEST_CREATE_WORKORDER_SUCCESS = 'REQUEST_CREATE_WORKORDER_SUCCESS'
export const REQUEST_CREATE_WORKORDER_ERROR = 'REQUEST_CREATE_WORKORDER_ERROR'
export const REQUEST_UPDATE_WORKORDER_SUCCESS = 'REQUEST_UPDATE_WORKORDER_SUCCESS'
export const REQUEST_UPDATE_WORKORDER_ERROR = 'REQUEST_UPDATE_WORKORDER_ERROR'

// Region
export const REQUEST_GET_REGION_SUCCESS = 'REQUEST_GET_REGION_SUCCESS'
export const REQUEST_GET_REGION_ERROR = 'REQUEST_GET_REGION_ERROR'

// Role
export const REQUEST_ROLE_LIST_SUCCESS = 'REQUEST_ROLE_LIST_SUCCESS'
export const REQUEST_ROLE_LIST_ERROR = 'REQUEST_ROLE_LIST_ERROR'

// DocumentType
export const REQUEST_GET_DOCUMENTTYPE_SUCCESS = 'REQUEST_GET_DOCUMENTTYPE_SUCCESS'
export const REQUEST_GET_DOCUMENTTYPE_ERROR = 'REQUEST_GET_DOCUMENTTYPE_ERROR'
export const REQUEST_GET_DOCUMENTTYPE_ARCHIVED_SUCCESS = 'REQUEST_GET_DOCUMENTTYPE_ARCHIVED_SUCCESS'
export const REQUEST_GET_DOCUMENTTYPE_ARCHIVED_ERROR = 'REQUEST_GET_DOCUMENTTYPE_ARCHIVED_ERROR'
export const REQUEST_CREATE_DOCUMENTTYPE_SUCCESS = 'REQUEST_CREATE_DOCUMENTTYPE_SUCCESS'
export const REQUEST_CREATE_DOCUMENTTYPE_ERROR = 'REQUEST_CREATE_DOCUMENTTYPE_ERROR'
export const REQUEST_UPDATE_DOCUMENTTYPE_SUCCESS = 'REQUEST_UPDATE_DOCUMENTTYPE_SUCCESS'
export const REQUEST_UPDATE_DOCUMENTTYPE_ERROR = 'REQUEST_UPDATE_DOCUMENTTYPE_ERROR '
export const REQUEST_ARCHIVE_DOCUMENTTYPE_SUCCESS = 'REQUEST_ARCHIVE_DOCUMENTTYPE_SUCCESS'
export const REQUEST_ARCHIVE_DOCUMENTTYPE_ERROR = 'REQUEST_ARCHIVE_DOCUMENTTYPE_ERROR'
export const REQUEST_RESTORE_DOCUMENTTYPE_SUCCESS = 'REQUEST_RESTORE_DOCUMENTTYPE_SUCCESS'
export const REQUEST_RESTORE_DOCUMENTTYPE_ERROR = 'REQUEST_RESTORE_DOCUMENTTYPE_ERROR'
export const CLEAR_DOCUMENTTYPE_ERROR = 'CLEAR_DOCUMENTTYPE_ERROR'

// Document
export const REQUEST_UPLOAD_DOCUMENT_SUCCESS = 'REQUEST_UPLOAD_DOCUMENT_SUCCESS'
export const REQUEST_UPLOAD_DOCUMENT_ERROR = 'REQUEST_UPLOAD_DOCUMENT_ERROR'
export const REQUEST_GET_DOCUMENT_SUCCESS = 'REQUEST_GET_DOCUMENT_SUCCESS'
export const REQUEST_GET_DOCUMENT_ERROR = 'REQUEST_GET_DOCUMENT_ERROR'
export const REQUEST_GET_DOCUMENTS_SUCCESS = 'REQUEST_GET_DOCUMENTS_SUCCESS'
export const REQUEST_GET_DOCUMENTS_ERROR = 'REQUEST_GET_DOCUMENTS_ERROR'
export const REQUEST_GET_DOCUMENT_TASK_SUCCESS = 'REQUEST_GET_DOCUMENT_TASK_SUCCESS'
export const REQUEST_GET_DOCUMENT_TASK_ERROR = 'REQUEST_GET_DOCUMENT_TASK_ERROR'
export const REQUEST_CREATE_DOCUMENT_SUCCESS = 'REQUEST_CREATE_DOCUMENT_SUCCESS'
export const REQUEST_CREATE_DOCUMENT_ERROR = 'REQUEST_CREATE_DOCUMENT_ERROR'
export const REQUEST_UPDATE_DOCUMENT_SUCCESS = 'REQUEST_UPDATE_DOCUMENT_SUCCESS'
export const REQUEST_UPDATE_DOCUMENT_ERROR = 'REQUEST_UPDATE_DOCUMENT_ERROR'
export const REQUEST_DELETE_DOCUMENT_SUCCESS = 'REQUEST_DELETE_DOCUMENT_SUCCESS'
export const REQUEST_DELETE_DOCUMENT_ERROR = 'REQUEST_DELETE_DOCUMENT_ERROR'
export const CLEAR_ERROR_DOCUMENT = 'CLEAR_ERROR_DOCUMENT'
export const CLEAR_DOCUMENT_TASK = 'CLEAR_DOCUMENT_TASK'

// Image
export const REQUEST_UPLOAD_IMAGE_SUCCESS = 'REQUEST_UPLOAD_IMAGE_SUCCESS'
export const REQUEST_UPLOAD_IMAGE_ERROR = 'REQUEST_UPLOAD_IMAGE_ERROR'
export const REQUEST_GET_IMAGES_SUCCESS = 'REQUEST_GET_IMAGES_SUCCESS'
export const REQUEST_GET_IMAGES_ERROR = 'REQUEST_GET_IMAGES_ERROR'
export const REQUEST_GET_IMAGE_SUCCESS = 'REQUEST_GET_IMAGE_SUCCESS'
export const REQUEST_GET_IMAGE_ERROR = 'REQUEST_GET_IMAGE_ERROR'
export const REQUEST_GET_IMAGE_TASK_SUCCESS = 'REQUEST_GET_IMAGE_TASK_SUCCESS'
export const REQUEST_GET_IMAGE_TASK_ERROR = 'REQUEST_GET_IMAGE_TASK_ERROR'
export const REQUEST_CREATE_IMAGE_SUCCESS = 'REQUEST_CREATE_IMAGE_SUCCESS'
export const REQUEST_CREATE_IMAGE_ERROR = 'REQUEST_CREATE_IMAGE_ERROR'
export const REQUEST_UPDATE_IMAGE_SUCCESS = 'REQUEST_UPDATE_IMAGE_SUCCESS'
export const REQUEST_UPDATE_IMAGE_ERROR = 'REQUEST_UPDATE_IMAGE_ERROR'
export const REQUEST_DELETE_IMAGE_SUCCESS = 'REQUEST_DELETE_IMAGE_SUCCESS'
export const REQUEST_DELETE_IMAGE_ERROR = 'REQUEST_DELETE_IMAGE_ERROR'
export const CLEAR_ERROR_IMAGE = 'CLEAR_ERROR_IMAGE'
export const CLEAR_IMAGE_TASK = 'CLEAR_IMAGE_TASK'

// Change Order
export const REQUEST_GET_ALL_CHANGE_ORDERS_SUCCESS = 'REQUEST_GET_ALL_CHANGE_ORDERS_SUCCESS'
export const REQUEST_GET_ALL_CHANGE_ORDERS_ERROR = 'REQUEST_GET_ALL_CHANGE_ORDERS_ERROR'
export const REQUEST_GET_CHANGE_ORDER_SUCCESS = 'REQUEST_GET_CHANGE_ORDER_SUCCESS'
export const REQUEST_GET_CHANGE_ORDER_ERROR = 'REQUEST_GET_CHANGE_ORDER_ERROR'
export const REQUEST_GET_CHANGE_ORDERS_BY_TASK_SUCCESS = 'REQUEST_GET_CHANGE_ORDERS_BY_TASK_SUCCESS'
export const REQUEST_GET_CHANGE_ORDERS_BY_TASK_ERROR = 'REQUEST_GET_CHANGE_ORDERS_BY_TASK_ERROR'
export const REQUEST_CREATE_CHANGE_ORDER_SUCCESS = 'REQUEST_CREATE_CHANGE_ORDER_SUCCESS'
export const REQUEST_CREATE_CHANGE_ORDER_ERROR = 'REQUEST_CREATE_CHANGE_ORDER_ERROR'
export const REQUEST_UPDATE_CHANGE_ORDER_SUCCESS = 'REQUEST_UPDATE_CHANGE_ORDER_SUCCESS'
export const REQUEST_UPDATE_CHANGE_ORDER_ERROR = 'REQUEST_UPDATE_CHANGE_ORDER_ERROR'
export const CLEAR_ERROR_CHANGE_ORDER = 'CLEAR_ERROR_CHANGE_ORDER'
export const REQUEST_DELETE_CHANGE_ORDER_SUCCESS = 'REQUEST_DELETE_CHANGE_ORDER_SUCCESS'
export const REQUEST_DELETE_CHANGE_ORDER_ERROR = 'REQUEST_DELETE_CHANGE_ORDER_ERROR'
export const CLEAR_CHANGE_TASK = 'CLEAR_CHANGE_TASK'

// Change Order Document
export const REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_SUCCESS = 'REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_SUCCESS'
export const REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_ERROR = 'REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_ERROR'
export const REQUEST_GET_CHANGE_ORDER_DOCUMENT_SUCCESS = 'REQUEST_GET_CHANGE_ORDER_DOCUMENT_SUCCESS'
export const REQUEST_GET_CHANGE_ORDER_DOCUMENT_ERROR = 'REQUEST_GET_CHANGE_ORDER_DOCUMENT_ERROR'
export const REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_SUCCESS = 'REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_SUCCESS'
export const REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_ERROR = 'REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_ERROR'
export const REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_SUCCESS = 'REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_SUCCESS'
export const REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_ERROR = 'REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_ERROR'
export const REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_SUCCESS = 'REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_SUCCESS'
export const REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_ERROR = 'REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_ERROR'
export const REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_SUCCESS = 'REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_SUCCESS'
export const REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_ERROR = 'REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_ERROR'
export const CLEAR_ERROR_CHANGE_DOCUMENT = 'CLEAR_ERROR_CHANGE_DOCUMENT'

// Checklist
export const REQUEST_GET_ALL_CHECKLISTS_LABELS_SUCCESS = 'REQUEST_GET_ALL_CHECKLISTS_LABELS_SUCCESS'
export const REQUEST_GET_ALL_CHECKLISTS_LABELS_ERROR = 'REQUEST_GET_ALL_CHECKLISTS_LABELS_ERROR'
export const REQUEST_GET_CHECKLIST_BY_TASK_SUCCESS = 'REQUEST_GET_CHECKLIST_BY_TASK_SUCCESS'
export const REQUEST_GET_CHECKLIST_BY_TASK_ERROR = 'REQUEST_GET_CHECKLIST_BY_TASK_ERROR'
export const REQUEST_GET_CHECKLIST_BY_ID_SUCCESS = 'REQUEST_GET_CHECKLIST_BY_ID_SUCCESS'
export const REQUEST_GET_CHECKLIST_BY_ID_ERROR = 'REQUEST_GET_CHECKLIST_BY_ID_ERROR'
export const REQUEST_ADD_CHECKLST_SUCCESS = 'REQUEST_ADD_CHECKLST_SUCCESS'
export const REQUEST_ADD_CHECKLST_ERROR = 'REQUEST_ADD_CHECKLST_ERROR'
export const REQUEST_UPDATE_CHECKLIST_SUCCESS = 'REQUEST_UPDATE_CHECKLIST_SUCCESS'
export const REQUEST_UPDATE_CHECKLIST_ERROR = 'REQUEST_UPDATE_CHECKLIST_ERROR'
export const REQUEST_DELETE_CHECKLIST_SUCCESS = 'REQUEST_DELETE_CHECKLIST_SUCCESS'
export const REQUEST_DELETE_CHECKLIST_ERROR = 'REQUEST_DELETE_CHECKLIST_ERROR'

// File
export const REQUEST_GET_ZIP_SUCCESS = 'REQUEST_GET_ZIP_SUCCESS'
export const REQUEST_GET_ZIP_ERROR = 'REQUEST_GET_ZIP_FAIL'
export const CLEAR_ERROR_SUCCESS_MESSAGES = 'CLEAR_ERROR_SUCCESS_MESSAGES'
export const REQUEST_GET_FILE_LIST_BY_TASK_SUCCESS = 'REQUEST_GET_FILE_LIST_BY_TASK_SUCCESS'
export const REQUEST_GET_FILE_LIST_BY_TASK_ERROR = 'REQUEST_GET_FILE_LIST_BY_TASK_ERROR'
export const REQUEST_GET_FILE_LIST_SUCCESS = 'REQUEST_GET_FILE_LIST_SUCCESS'
export const REQUEST_GET_FILE_LIST_ERROR = 'REQUEST_GET_FILE_LIST_ERROR'

// Loading Indicator
export const ENABLE_LOADING_INDICATOR = 'ENABLE_LOADING_INDICATOR'
export const DISABLE_LOADING_INDICATOR = 'DISABLE_LOADING_INDICATOR'
